import { JobSalaryType } from "@relode/core/domain";
import { Formik } from "formik";
import * as React from "react";

import { AddJobSeedData, AddJobSteps } from "../types";
import { AddJobProvider } from "./addJobProvider";
import { addJobSchema } from "./validationSchema";

export const AddJobForm = (props: {
    children: React.ReactNode;
    seedData?: AddJobSeedData;
}) => {
    const { seedData } = props;
    const initialData = React.useMemo(() => {
        const init = AddJobSteps.create();
        if (!!seedData) {
            init.stepTwo.jobName = seedData.jobName;
            init.stepTwo.jobTypeId = seedData.jobType.jobTypeId;
            init.stepTwo.jobSalaryInUSDollars = seedData.salary;
            init.stepTwo.jobSalaryTypeId = seedData.jobType.isFullTimeOrPartTime()
                ? JobSalaryType.PerYear.id
                : JobSalaryType.PerHour.id;
        }
        return init;
    }, [seedData]);
    return (
        <Formik
            initialValues={initialData}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSubmit={() => {}}
            validateOnBlur={false}
            validateOnChange={false}
            validationSchema={addJobSchema}
        >
            <AddJobProvider>{props.children}</AddJobProvider>
        </Formik>
    );
};
